import { combineReducers } from 'redux';

import * as types from 'modules/campaigns/actionTypes';
import { DUPLICATE_MODAL_SOURCE } from 'modules/campaigns/constants';
import loading from 'modules/global/reducers/generic.loading';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *  open: boolean,
 *  creating: boolean,
 * }} CampaignUIModalDuplicateReducer
 */

export default combineReducers({
  open: createReducer(false, {
    [types.OPEN_MODAL_DUPLICATE]: () => true,
    [types.CLOSE_MODAL_DUPLICATE]: () => false,
    [types.DUPLICATE_CAMPAIGN_SUCCESS]: () => false,
  }),
  creating: loading(types.DUPLICATE_CAMPAIGN, {
    global: { matcher: ({ meta }) => meta.source === DUPLICATE_MODAL_SOURCE },
  }),
});
